var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#26A69A"
    },
    cx: 24,
    cy: 24,
    r: 25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    style: {
      fill: "#FFFFFF"
    },
    width: 18,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M24,21c-4.457,0-12,0.737-12,3.5S19.543,28,24,28s12-0.737,12-3.5S28.457,21,24,21z M24,26 c-5.523,0-10-0.895-10-2c0-1.105,4.477-2,10-2s10,0.895,10,2C34,25.105,29.523,26,24,26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M24,24c1.095,0,2.093-0.037,3-0.098V13h-6v10.902C21.907,23.963,22.905,24,24,24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M25.723,25.968c-0.111,0.004-0.223,0.007-0.336,0.01C24.932,25.991,24.472,26,24,26 s-0.932-0.009-1.387-0.021c-0.113-0.003-0.225-0.006-0.336-0.01c-0.435-0.015-0.863-0.034-1.277-0.06V36h6V25.908 C26.586,25.934,26.158,25.953,25.723,25.968z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Man_With_Money"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Man_With_Money_1_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Man_With_Money_2_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Comparing"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Showing_Big_Size"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Afraid"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Mad"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Faint"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Winner"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Beach"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Island_On_Water"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.bb3f21e072026a01807219e09f2391f7.svg";
export { ForwardRef as ReactComponent };